/* SAWATELL — custom storefront JS: reveal animations, header, drawer, search, cart count */
(function () {
  'use strict';

  function reveal() {
    var els = document.querySelectorAll('.sw-fade, .sw-stagger');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in-view'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function header() {
    var h = document.querySelector('[data-sw-header]');
    var group = document.querySelector('.shopify-section-group-header-group');
    var lastY = window.pageYOffset || 0;
    var ticking = false;
    var drawerOpen = false;

    function onScroll() {
      var y = window.pageYOffset || 0;
      if (h) {
        if (y > 24) h.setAttribute('data-stuck', 'true');
        else h.removeAttribute('data-stuck');
      }
      // While the drawer is open, never transform the header group: a transformed
      // ancestor becomes the containing block for the fixed drawer and drags it off-screen.
      if (group && !drawerOpen) {
        if (y <= 4) {
          // Always visible at the very top
          group.classList.remove('is-hidden');
        } else if (Math.abs(y - lastY) > 6) {
          if (y > lastY && y > 140) group.classList.add('is-hidden');  // scrolling down
          else group.classList.remove('is-hidden');                    // scrolling up
        }
      }
      lastY = y;
      ticking = false;
    }

    onScroll();
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });

    var drawer = document.querySelector('[data-sw-drawer]');
    var overlay = document.querySelector('[data-sw-overlay]');
    function open() { drawerOpen = true; if (group) group.classList.remove('is-hidden'); if (drawer) drawer.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { drawerOpen = false; if (drawer) drawer.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-sw-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-sw-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // Mobile accordion sub-menus
    document.querySelectorAll('[data-sw-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = btn.closest('.sw-draw__group');
        if (p) p.classList.toggle('open');
      });
    });
  }

  function carousels() {
    document.querySelectorAll('[data-sw-carousel]').forEach(function (caro) {
      // Tabs
      var tabs = caro.querySelectorAll('[data-sw-tab]');
      var panels = caro.querySelectorAll('[data-sw-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-sw-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-sw-panel') === idx); });
          window.dispatchEvent(new Event('resize'));
        });
      });

      // Arrows per panel
      panels.forEach(function (panel) {
        var track = panel.querySelector('[data-sw-track]');
        if (!track) return;
        var prev = panel.querySelector('[data-sw-prev]');
        var next = panel.querySelector('[data-sw-next]');
        function step() {
          var first = track.firstElementChild;
          var w = first ? first.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
          return Math.max(w, Math.round(track.clientWidth * 0.8));
        }
        function update() {
          var max = track.scrollWidth - track.clientWidth - 2;
          if (prev) prev.toggleAttribute('hidden', track.scrollLeft <= 2);
          if (next) next.toggleAttribute('hidden', track.scrollLeft >= max);
        }
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
      });
    });
  }

function loader(){
  var el=document.querySelector("[data-sw-loader]");
  if(!el)return;
  var start=Date.now(),MIN=650,MAX=2500,done=false;
  function hide(){
    if(done)return;done=true;
    var wait=Math.max(0,MIN-(Date.now()-start));
    setTimeout(function(){
      el.classList.add("is-done");
      setTimeout(function(){el.parentNode&&el.parentNode.removeChild(el)},700);
    },wait);
  }
  // Don't wait for ads, maps, chat or iframes: hide when the hero image is ready, or at MAX.
  var hero=document.querySelector("[data-sw-hero-slides] img, main img");
  if(!hero||hero.complete){hide();}
  else{hero.addEventListener("load",hide);hero.addEventListener("error",hide);}
  setTimeout(hide,MAX);
}

  function heroKen() {
    document.querySelectorAll('[data-sw-hero-slides]').forEach(function (box) {
      var slides = box.querySelectorAll('.sw-hero__slide');
      if (slides.length < 2) return;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, 5200);
    });
  }

  function swReviews() {
    var box = document.querySelector('[data-sw-reviews]');
    if (!box) return;
    var key = box.getAttribute('data-gr-key');
    var place = box.getAttribute('data-gr-place');
    if (!key || !place) return; // no credentials → keep seed reviews as fallback

    // Translatable UI strings: JS can't use the {{ | t }} filter, so they arrive as
    // data-attributes from the Liquid section. French fallbacks keep it working if absent.
    var T = {
      countPrefix: box.getAttribute('data-t-count-prefix') || 'Basé sur ',
      countSuffix: box.getAttribute('data-t-count-suffix') || ' avis Google',
      starsSuffix: box.getAttribute('data-t-stars-suffix') || 'étoiles sur 5',
      author: box.getAttribute('data-t-author') || 'Client Google',
      more: box.getAttribute('data-t-more') || 'Google Reviews →'
    };

    var GG = '<svg viewBox="0 0 24 24" width="20" height="20"><path fill="#4285F4" d="M23.5 12.27c0-.79-.07-1.54-.2-2.27H12v4.51h6.47a5.53 5.53 0 0 1-2.4 3.63v3h3.88c2.27-2.09 3.55-5.17 3.55-8.87z"/><path fill="#34A853" d="M12 24c3.24 0 5.96-1.08 7.95-2.91l-3.88-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.27v3.09A12 12 0 0 0 12 24z"/><path fill="#FBBC05" d="M5.27 14.29A7.21 7.21 0 0 1 4.89 12c0-.8.14-1.57.38-2.29V6.62H1.27A12 12 0 0 0 0 12c0 1.94.46 3.77 1.27 5.38z"/><path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.43-3.43C17.95 1.19 15.24 0 12 0A12 12 0 0 0 1.27 6.62l4 3.09C6.22 6.86 8.87 4.75 12 4.75z"/></svg>';
    var PALETTE = ['30, 95, 184', '0, 61, 144', '15, 118, 110', '180, 83, 9', '124, 58, 237'];

    function esc(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function starsHtml(rating) {
      var html = '';
      for (var i = 1; i <= 5; i++) {
        html += i <= Math.round(rating) ? '<span>★</span>' : '<span class="sw-rev__star--off">★</span>';
      }
      return html;
    }

    var lang = (document.documentElement.lang || 'fr').slice(0, 2);

    // Loads the Google Maps JS API once (exposes google.maps.importLibrary → new Places API).
    function loadMaps() {
      if (window.google && window.google.maps && window.google.maps.importLibrary) return Promise.resolve();
      if (window.__swMapsPromise) return window.__swMapsPromise;
      window.__swMapsPromise = new Promise(function (resolve, reject) {
        window.__swReviewsCb = function () { resolve(); };
        var sc = document.createElement('script');
        sc.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) +
          '&libraries=places&v=weekly&language=' + encodeURIComponent(lang) +
          '&loading=async&callback=__swReviewsCb';
        sc.async = true; sc.defer = true;
        sc.onerror = function () { reject(new Error('maps load failed')); };
        document.head.appendChild(sc);
      });
      return window.__swMapsPromise;
    }

    loadMaps()
      .then(function () { return google.maps.importLibrary('places'); })
      .then(function (placesLib) {
        // Places API (New): Place + fetchFields (legacy PlacesService is not enabled on this project).
        var placeObj = new placesLib.Place({ id: place, requestedLanguage: lang });
        return placeObj.fetchFields({ fields: ['rating', 'userRatingCount', 'reviews', 'googleMapsURI'] });
      })
      .then(function (res) {
        var data = res && res.place;
        if (!data) return;

        // Update the aggregate badge with live figures
        if (typeof data.rating === 'number') {
          var scoreEl = box.querySelector('[data-sw-rev-score]');
          if (scoreEl) scoreEl.textContent = data.rating.toFixed(1).replace('.', ',');
          var bStars = box.querySelector('[data-sw-rev-badge-stars]');
          if (bStars) bStars.textContent = '★★★★★'.slice(0, Math.round(data.rating)) + '☆☆☆☆☆'.slice(0, 5 - Math.round(data.rating));
        }
        if (typeof data.userRatingCount === 'number') {
          var countEl = box.querySelector('[data-sw-rev-count]');
          if (countEl) countEl.textContent = T.countPrefix + data.userRatingCount + T.countSuffix;
        }

        var reviews = (data.reviews || []).filter(function (r) { return r && r.text; });
        if (!reviews.length) return; // keep seed cards

        var track = box.querySelector('[data-sw-track]');
        if (!track) return;
        track.innerHTML = reviews.map(function (r, idx) {
          var attr = r.authorAttribution || {};
          var name = esc(attr.displayName || T.author);
          var initial = name.charAt(0).toUpperCase();
          var color = PALETTE[idx % PALETTE.length];
          return '<article class="sw-rev">' +
              '<div class="sw-rev__top">' +
                '<span class="sw-rev__avatar" style="--c: ' + color + '">' + initial + '</span>' +
                '<div class="sw-rev__id">' +
                  '<strong>' + name + '</strong>' +
                  '<span>' + esc(r.relativePublishTimeDescription || '') + '</span>' +
                '</div>' +
                '<span class="sw-rev__g" aria-hidden="true">' + GG + '</span>' +
              '</div>' +
              '<div class="sw-rev__stars" aria-label="' + (r.rating || 5) + ' ' + esc(T.starsSuffix) + '">' + starsHtml(r.rating || 5) + '</div>' +
              '<p class="sw-rev__text">' + esc(r.text) + '</p>' +
            '</article>';
        }).join('');

        // Optional "see all reviews" link
        var profile = box.getAttribute('data-gr-profile') || data.googleMapsURI;
        var head = box.querySelector('.sw-rev-head');
        if (profile && head && !box.querySelector('[data-sw-rev-more]')) {
          var a = document.createElement('a');
          a.className = 'sw-link';
          a.href = profile; a.target = '_blank'; a.rel = 'noopener nofollow';
          a.setAttribute('data-sw-rev-more', '');
          a.textContent = T.more;
          var headText = head.querySelector('div');
          if (headText) headText.appendChild(a);
        }

        // Refresh carousel arrow state for the new content
        window.dispatchEvent(new Event('resize'));
      })
      .catch(function () { /* keep seed reviews as fallback */ });
  }

  function cartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-sw-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.setAttribute('data-count', c.item_count);
      });
    }).catch(function () {});
  }

  function init() { loader(); reveal(); header(); heroKen(); carousels(); swReviews(); cartCount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();